export class BookingPage {
    accountSession: AccountSession = new AccountSession();
    createSessionDays: CreateSessionDay[];
    createSessionQuestions: any[];
    sessionQuestionWihtOptions: SessionQuestionWihtOptions;
    sessionFormQuestions: SessionFormQuestions;
  }
  
  export class SessionFormQuestions {
    accountSessionId: number;
    formData: FormData = new FormData();
    status: string;
  }
  
  export class FormData {
    children: any[];
    template: Template;
    footerActions: any[];
  }
  
  export class Template {
    columns: number;
    spacing: string;
    className: string;
  }
  
  export class SessionQuestionWihtOptions {
    questionsList: any[];
  }
  
  export class CreateSessionDay {
    sessionDay: SessionDay;
    createSessionDayTimes: CreateSessionDayTime[];
  }
  
  export class CreateSessionDayTime {
    sessionDayId: number;
    startTime: string;
    endTime: string;
    status: string;
  }
  
  export class SessionDay {
    accountSessionId: number;
    dayId: number;
    status: string;
  }
  
  export class AccountSession {
    uuid: string;
    account_uuid: string;
    targetBankId: string;
    name: string;
    duration: number;
    noOfAgents: number;
    templateId: number;
    startDate: string;
    endDate: string;
    paymentOption: string;
    amount: number;
    appointmentLink: string;
    clientNotification?: any;
    agentNotification?: any;
    timezone: number;
    status: string;
    createdAt: string;
    updatedAt: string;
    conflict_ref_id:number = null;
    calendar_view: BookingPageView = 'DAY';
  }
  

  export class getAvailableTimeSlotsPayload{
    sessionUuid: string;
    dayId:number;
    startDate: string;
    endDate:string;
    userTimeZone:string;
    activityDates:any[];
  } 

  export type BookingPageView = 'DAY' | 'WEEK' | 'MONTH';
  